import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from 'axios';
import baseURL, { getAuthHeaders } from './baseUrl';

const Clients = () => {
  const [activeTab, setActiveTab] = useState('create');
  const [clientData, setClientData] = useState({
    name: '',
    whatsappNo: '',
  });
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);
  const [responseMessage, setResponseMessage] = useState('');

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setResponseMessage('');
    setSearchResults([]);
    setSearchQuery('');
  };

  const handleChange = (e) => {
    setClientData({
      ...clientData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `${baseURL}/api/clients/register`,
        {
          name: clientData.name.trim(),
          whatsappNo: clientData.whatsappNo.trim(),
        },
        { headers: getAuthHeaders() }
      );

      setResponseMessage(
        `Client registered successfully: ${response.data.name}` +
          (response.data.whatsappNo ? ` (WhatsApp: ${response.data.whatsappNo})` : '')
      );
      setClientData({ name: '', whatsappNo: '' });
    } catch (error) {
      console.error(error);
      setResponseMessage(
        `Error: ${error.response?.data?.error || error.response?.data?.message || error.message}`
      );
    }
  };

  const handleSearchChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);

    if (query.length > 0) {
      handleSearch(query);
    } else {
      setSearchResults([]);
      setResponseMessage('');
    }
  };

  const handleSearch = async (query) => {
    try {
      const response = await axios.get(`${baseURL}/api/clients/search`, {
        params: { query },
        headers: getAuthHeaders(),
      });
      setSearchResults(response.data || []);
      setResponseMessage('');
    } catch (error) {
      console.error(error);
      if (error.response?.status === 404) {
        setSearchResults([]);
        setResponseMessage('No clients found');
      } else {
        setResponseMessage(
          `Error: ${error.response?.data?.error || error.response?.data?.message || error.message}`
        );
      }
    }
  };

  return (
    <div className="container mt-5">
      <div className="card">
        <div className="card-header">
          <ul className="nav nav-tabs card-header-tabs">
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${activeTab === 'create' ? 'active' : ''}`}
                onClick={() => handleTabChange('create')}
              >
                Create Client
              </button>
            </li>
            <li className="nav-item">
              <button
                type="button"
                className={`nav-link ${activeTab === 'search' ? 'active' : ''}`}
                onClick={() => handleTabChange('search')}
              >
                Search Clients
              </button>
            </li>
          </ul>
        </div>
        <div className="card-body">
          {activeTab === 'create' && (
            <div className="create-client">
              <h5 className="card-title">Create Client</h5>
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label">Name</label>
                  <input
                    type="text"
                    name="name"
                    value={clientData.name}
                    onChange={handleChange}
                    className="form-control"
                    required
                  />
                </div>
                <div className="mb-3">
                  <label className="form-label">WhatsApp Number</label>
                  <input
                    type="tel"
                    name="whatsappNo"
                    value={clientData.whatsappNo}
                    onChange={handleChange}
                    className="form-control"
                    placeholder="e.g. 9876543210 or 919876543210"
                  />
                  <div className="form-text">
                    10-digit Indian number or with country code. Used to send transaction details.
                  </div>
                </div>
                <button type="submit" className="btn btn-primary">
                  Register Client
                </button>
              </form>
              {responseMessage && <div className="alert alert-info mt-3">{responseMessage}</div>}
            </div>
          )}

          {activeTab === 'search' && (
            <div className="search-client">
              <h5 className="card-title">Search Clients</h5>
              <div className="mb-3">
                <label className="form-label">Search by Name</label>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="form-control"
                />
              </div>
              {responseMessage && <div className="alert alert-info mt-3">{responseMessage}</div>}
              {searchResults.length > 0 && (
                <ul className="list-group mt-3">
                  {searchResults.map((client) => (
                    <li key={client._id} className="list-group-item">
                      <strong>Name:</strong> {client.name}
                      {client.whatsappNo ? (
                        <>
                          {' '}
                          | <strong>WhatsApp:</strong> {client.whatsappNo}
                        </>
                      ) : (
                        <>
                          {' '}
                          | <span className="text-muted">No WhatsApp number</span>
                        </>
                      )}
                    </li>
                  ))}
                </ul>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Clients;
